import { Box } from "@chakra-ui/react";
import PayDetail from "./PayDetail";
import Tip from "./Tip";
import PayButton from "./PayButton";
import { TokenInfo } from "@/context/UserInfo";
import ErrorText from "./ErrorText";
import { Order } from "@/api/order";
import TitleHeader from "@/components/TitleHeader";
import { useNavigate } from "react-router-dom";

const Pay = ({
  isNormalPay,
  networkFeeAmount,
  networkFeeValue,
  swapBeforeError,
  swapAfterError,
  balanceDue,
  selectedToken,
  currentTip,
  orderDetail,
  onConfirm,
  customTip,
  tipActiveIndex,
  onTipActiveIndexChange,
  onTipOpen,
  onSelectAssetOpen,
}: {
  isNormalPay: boolean;
  networkFeeAmount: string;
  networkFeeValue: string;
  swapBeforeError: string;
  swapAfterError: string;
  balanceDue: string;
  selectedToken: TokenInfo | null;
  currentTip: string;
  orderDetail: Order | null;
  onConfirm: () => void;
  customTip: string;
  tipActiveIndex: number;
  onTipActiveIndexChange: (index: number, tipAmount: string) => void;
  onTipOpen: () => void;
  onSelectAssetOpen: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: "100%",
        overflow: "auto",
        padding: "20px",
        paddingBottom: "160px",
        color: "#fff",
        position: "relative",
      }}
    >
      <TitleHeader
        title="Pay to"
        onBack={() => {
          navigate("/");
        }}
        showSwitch={true}
      />
      <PayDetail
        isNormalPay={isNormalPay}
        networkFeeAmount={networkFeeAmount}
        networkFeeValue={networkFeeValue}
        balanceDue={balanceDue}
        selectedToken={selectedToken}
        onSelectAssetOpen={onSelectAssetOpen}
        currentTip={currentTip}
        orderDetail={orderDetail}
      ></PayDetail>
      {isNormalPay && (
        <Tip
          orderAmount={orderDetail?.orderAmount || "0"}
          customTip={customTip}
          activeIndex={tipActiveIndex}
          onActiveIndexChange={onTipActiveIndexChange}
          onTipOpen={onTipOpen}
        ></Tip>
      )}
      {swapBeforeError && (
        <ErrorText error={swapBeforeError || swapAfterError}></ErrorText>
      )}
      {swapAfterError && <ErrorText error={swapAfterError}></ErrorText>}
      <PayButton error={swapBeforeError} onConfirm={onConfirm}></PayButton>
    </Box>
  );
};
export default Pay;
